<template>
    <div>
        <!-- Billing Cycle Plans -->
        <template v-if="price.billing_cycle &&
                        price.custom_data &&
                        price.custom_data.type === 'core' &&
                        ((monthlyBilledTab && price.billing_cycle.interval === 'month') ||
                        (!monthlyBilledTab && price.billing_cycle.interval === 'year'))">

            <!-- Paid plans -->
            <template v-if="!zeroAmountPrice(price.unit_price.amount)">
                <p class="newPlanPricing">
                    <b>
                        {{ getCurrencySymbol(price.unit_price.currency_code) }}{{ price.billing_cycle.interval === 'year' ?
                            getMonthlyPrice(convertAmount(price.unit_price.amount)) :
                            convertAmount(price.unit_price.amount) }}/mo
                    </b>
                </p>

                <!-- Billed Annually or Monthly -->
                 <p>
                    Billed <span v-if="monthlyBilledTab">Monthly</span>
                            <span v-else>
                                Annually ({{ getCurrencySymbol(price.unit_price.currency_code) }}{{ convertAmount(price.unit_price.amount) }}/yr)
                            </span>
                 </p>

                <!-- Check for Trial Period -->
                <p v-if="price.trial_period != null"
                    style="color: #29ABE2;
                    font-weight: 600;
                    margin-top: 5px;">
                    {{ getFreeTrialPeriod(price.trial_period) }}
                </p>

            </template>
            <!-- Free plans -->
            <template v-else>
                <p class="newPlanPricing"><b>FREE</b></p>
                <p>
                    No Billing
                </p>
                <p style="color: #29ABE2;
                    font-weight: 600;
                    margin-top: 5px;"
                >
                    FOREVER
                </p>
            </template>

            <!-- {{ price.custom_data }} -->
            <PriceCaptions :price="price"/>

        </template>

        <!-- One Time Plans -->
        <template v-else-if="price.billing_cycle == null">

            <template v-if="!zeroAmountPrice(price.unit_price.amount)">
                <p class="newPlanPricing">
                    <b>
                        {{ getCurrencySymbol(price.unit_price.currency_code) }}
                        {{ convertAmount(price.unit_price.amount) }}
                    </b>
                </p>

                <!-- Billed One Time -->
                <p>
                    Billed One Time
                </p>

                <!-- Check for Trial Period -->
                <p v-if="price.trial_period != null"
                    style="color: #29ABE2;
                    font-weight: 600;
                    margin-top: 5px;">
                    {{ getFreeTrialPeriod(price.trial_period) }}
                </p>

                <PriceCaptions :price="price"/>

            </template>

        </template>

    </div>
</template>

<script>
import { paddleMixin } from '@/mixins/paddle/paddle'
import PriceCaptions from './PriceCaptions.vue'

export default {
    mixins: [paddleMixin],
    components:{
        PriceCaptions
    },
  props:{
        price:{
            type:Object,
            required:true,
            default:() => []
        },
        monthlyBilledTab:{
            type:Boolean,
            required:true,
            default:() => false
        }
    },
    data() {
        return {

        }
    },
    created() {

    },
    mounted () {

    },
    methods:{

    }
}
</script>